module.exports = __webpack_public_path__ + "static/img/nav-performance.e8379f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav-performance.png
// module id = Bwgh
// module chunks = 0